export function removeOpacity(data) {
  data.map(d => d.targets).map(t => (document.querySelector(t).style.opacity = ''))
}

export function addOpacity(data) {
  data.map(d => d.targets).map(t => (document.querySelector(t).style.opacity = 1))
}
